export const Collapse = () => {
  $('.collapse-item').on('click', function () {
    $(this).toggleClass('active');
  });
};
